import ServiceResponse from '@services/models/ServiceResponse';
import { productNeedReliableAgeValidationURL } from '@services/urls/apiGatewayURLs';

const message = 'products and vendor are required';

async function getProductsRequireValidate({ axios, vendor, products }) {
  try {
    if (!products || !vendor) return new ServiceResponse({ error: message });

    const { data } = await axios.post(productNeedReliableAgeValidationURL, {
      products,
      vendor,
    });

    return new ServiceResponse({ data });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getProductsRequireValidate;
